import { CdpaButtonComponent, CdpaButtonId } from "../../common/components/cdpaButton.component";
import { CdpaCheckboxComponent } from "../../common/components/cdpaCheckbox.components";
import { CdpaInputComponent, CdpaInputId } from "../../common/components/cdpaInput.component";
import { attachValidationOnSubmitClick } from "./formHelpers/formHelpers";
import { FormId } from "./common/formId";
import "./register.scss";
import "./template.scss";
export class Register {
    constructor() {
        const emailInput = new CdpaInputComponent(CdpaInputId.Email);
        const form = document.getElementById(FormId.Register);
        const usernameInput = new CdpaInputComponent(CdpaInputId.RegisterUsername);
        const requiredConsentCheckbox = new CdpaCheckboxComponent("consents");
        // Initialize marketing checkboxes so that they send metrics when toggled
        new CdpaCheckboxComponent("newsletterConsent");
        new CdpaCheckboxComponent("thirdPartyConsent");
        const submitButton = new CdpaButtonComponent(CdpaButtonId.Register);
        attachValidationOnSubmitClick(submitButton, form, [emailInput, usernameInput, requiredConsentCheckbox]);
        emailInput.checkForBackendValidated();
    }
}
